import { render, staticRenderFns } from "./kepemilikanrumah.vue?vue&type=template&id=79ed7f06"
import script from "./kepemilikanrumah.vue?vue&type=script&lang=js"
export * from "./kepemilikanrumah.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports